export default "__VITE_ASSET__aK4UwP3A__"